import { render, staticRenderFns } from "./TournamentWatchLive.vue?vue&type=template&id=4c5fc548&functional=true&"
import script from "./TournamentWatchLive.vue?vue&type=script&lang=js&"
export * from "./TournamentWatchLive.vue?vue&type=script&lang=js&"
import style0 from "./TournamentWatchLive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5fc548')) {
      api.createRecord('4c5fc548', component.options)
    } else {
      api.rerender('4c5fc548', component.options)
    }
    module.hot.accept("./TournamentWatchLive.vue?vue&type=template&id=4c5fc548&functional=true&", function () {
      api.rerender('4c5fc548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentWatchLive.vue"
export default component.exports